import { getUserRoles } from "../../../services/userService";

const schema = async () => {
  const s = {
    type: "object",
    properties: {
      name: {
        type: "string",
        minLength: 3,
        customRender: "typeahead",
      },
      email: {
        type: "string",
        format: "email",
      },
      userName: {
        type: "string",
        format: "email",
      },
      userRoleId: {
        type: "string",
        format: "uuid",
      },
      imageSrc: {
        type: ["string", "null"],
      },
    },
    required: ["name", "userRoleId"],
  };

  const roles_response = await getUserRoles();

  s.properties.userRoleId.oneOf = roles_response.data.map((r) => ({
    const: r.id,
    title: r.name,
  }));

  return s;
};

export default schema;
